import {Layout, LayoutContent} from '@logistics-frontend/blocks/legacy'
import {useI18n} from '@logistics-frontend/core/i18n'
import {Tariffs} from '@logistics-frontend/modules/tariffs-v2'
import {TariffsPageParams} from '@logistics-frontend/modules/tariffs-v2/types'
import React from 'react'
import {Helmet} from 'react-helmet-async'

import {fetchTariffList, fetchTariffZones} from 'src/api'
import {config} from 'src/config'

const detectedCountry = config.config.detectedCountry

const urls = (params: TariffsPageParams) => ({
  countryUrl: ({country}: Partial<TariffsPageParams>) => `/${country}`,
  zoneUrl: ({zone, country = params.country}: Partial<TariffsPageParams>) => `/${country}/${zone}`,
  zone: {
    categoryUrl: ({zone, category, country = params.country}: Partial<TariffsPageParams>) =>
      `/${country}/${zone}/${category}`,
  },
})

type Props = {
  match: {
    params: TariffsPageParams
  }
}

const TariffsPage: React.FC<React.PropsWithChildren<Props>> = ({match}) => {
  const t = useI18n()

  return (
    <>
      <Helmet>
        <title>{t('public.tariffs.title')}</title>
      </Helmet>
      <Layout layout="noSidebar">
        <LayoutContent data-e2e="page-tariffs">
          <Tariffs
            defaultCountry={detectedCountry}
            fetchTariffs={fetchTariffList}
            fetchZones={fetchTariffZones}
            urls={urls(match.params)}
          />
        </LayoutContent>
      </Layout>
    </>
  )
}

export default TariffsPage
